import { Trash2, Loader2 } from "lucide-react";

export const AdminTestimonialsTable = ({ rows, deletingId, onDelete }) => (
  <div className="overflow-x-auto rounded-xl border border-white/10">
    <table className="w-full text-sm" data-testid="admin-testimonials-table">
      <thead>
        <tr className="border-b border-white/10 text-neutral-500 text-xs uppercase tracking-wide">
          <th className="text-left font-medium px-4 py-3">Nombre</th>
          <th className="text-left font-medium px-4 py-3">Rol</th>
          <th className="text-left font-medium px-4 py-3">Opinión</th>
          <th className="text-left font-medium px-4 py-3">Fecha</th>
          <th className="text-left font-medium px-4 py-3">IP</th>
          <th className="text-left font-medium px-4 py-3">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id} data-testid={`admin-testimonial-row-${r.id}`} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
            <td className="px-4 py-3 font-semibold whitespace-nowrap">{r.name}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">{r.role}</td>
            <td className="px-4 py-3 text-neutral-300 max-w-md">{r.quote}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">
              {r.submitted_at ? new Date(r.submitted_at).toLocaleString("es-MX") : "—"}
            </td>
            <td className="px-4 py-3 text-neutral-400 font-mono text-xs">{r.ip_address}</td>
            <td className="px-4 py-3">
              <button
                onClick={() => onDelete(r.id)}
                disabled={deletingId === r.id}
                data-testid={`admin-delete-testimonial-${r.id}`}
                className="flex items-center gap-1.5 text-xs font-semibold text-white bg-brand-red/90 hover:bg-brand-red px-3 py-1.5 rounded-full transition-colors disabled:opacity-50"
              >
                {deletingId === r.id ? <Loader2 className="w-3 h-3 animate-spin" /> : <Trash2 className="w-3 h-3" />}
                Eliminar
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
